import React from "react";

const MapComponent = ({ map }) => {
  return (
    <div style={{ height: "400px", width: "100%" }}>
      {map ? (
        React.cloneElement(map, {
          style: { height: "100%", width: "100%", border: "none" },
          title: "Map",
        })
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <p>No map available</p>
        </div>
      )}
    </div>
  );
};

export default MapComponent;
